import dayjs from 'dayjs';
import { getIdFromGid } from '../../utils/gid-utils';

export const stubSubscriptionItems = (situation: string): Subscriptions => {
  switch (situation) {
    case 'test-single-subscription':
    case '1':
      return { Items: [TEST_SUBSCRIPTION_1] };
    case 'test-multiple-subscriptions':
    case '2':
      return {
        Items: [
          TEST_SUBSCRIPTION_5,
          TEST_SUBSCRIPTION_1,
          TEST_SUBSCRIPTION_2,
          TEST_SUBSCRIPTION_6,
          TEST_SUBSCRIPTION_3,
          TEST_SUBSCRIPTION_4,
        ],
      };
    default:
      return { Items: [TEST_SUBSCRIPTION_1] };
  }
};

export const stubSubscriptionItemDetails = (
  subscriptionId: string | null,
): Promise<Subscription> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (subscriptionId) {
        resolve(subscriptionMap[subscriptionId]);
      } else {
        reject(new Error('fatal error, 502'));
      }
    }, 700);
  });
};

// SubscriptionContractNextBillingDate: '2021-09-21T10:00:00Z'
// NextBillingYearMonth: '2021-09'
const nextBillingDateOneMonth = dayjs().add(1, 'month').format();
const nextBillingDateTwoWeeks = dayjs().add(2, 'week').format();
const nextBillingYearMonth = dayjs().add(1, 'month').format('YYYY-MM');

export const stubProductImages = (subscription) =>
  subscription.Lines.map((line) => {
    return {
      id: getIdFromGid(line.ProductId),
      featuredImage: line.VariantImageSrc,
      variants: [],
    };
  });

const LINE_1 = {
  ProductId: 'gid://shopify/Product/line1',
  RequiresShipping: true,
  LineDiscountedPriceCurrencyCode: 'USD',
  SellingPlanName: '1 month',
  CurrentPriceCurrencyCode: 'USD',
  VariantId: 'gid://shopify/ProductVariant/38297425182914',
  Quantity: 1,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  SellingPlanId: 'gid://shopify/SellingPlan/41615554',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  SubscriptionContractId: 'gid://shopify/SubscriptionContract/TEST1234',
  SubscriptionContractLineId:
    'gid://shopify/SubscriptionLine/671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  VariantImageSrc: null,
  CurrentPriceAmount: '15.17',
  Title: 'Test Product',
  VariantTitle: '',
  ItemTypeSubscriptionStatusNextBillingDate: `SCL#ACTIVE#${nextBillingDateOneMonth}`,
  SK: '#SCL#671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  PK: 'SC#TEST1234',
  LineDiscountedPriceAmount: '15.17',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST1',
  FormattedItemPrice: '$15.17',
  FormattedLineTotal: '$15.17',
};

const LINE_2 = {
  ProductId: 'gid://shopify/Product/line2',
  RequiresShipping: true,
  LineDiscountedPriceCurrencyCode: 'USD',
  SellingPlanName: '2 weeks',
  CurrentPriceCurrencyCode: 'USD',
  VariantId: 'gid://shopify/ProductVariant/38297425182914',
  Quantity: 3,
  NextBillingDate: nextBillingDateTwoWeeks,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  SellingPlanId: 'gid://shopify/SellingPlan/41615554',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  SubscriptionContractId: 'gid://shopify/SubscriptionContract/TEST',
  SubscriptionContractLineId:
    'gid://shopify/SubscriptionLine/671f3d8a-f680-49b2-b079-2a75fa58a4cd',
  VariantImageSrc:
    'https://cdn.shopify.com/s/files/1/0507/1611/5138/products/Capturadepantalla2021-05-17ala_s_6.22.36p.m._350x350.png?v=1621293781',
  CurrentPriceAmount: '10.05',
  Title: 'Test Product 2',
  VariantTitle: 'Red / Small',
  ItemTypeSubscriptionStatusNextBillingDate: `SCL#ACTIVE#${nextBillingDateTwoWeeks}`,
  SK: '#SCL#671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  PK: 'SC#TEST',
  LineDiscountedPriceAmount: '10.05',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST',
  FormattedItemPrice: '$10.05',
  FormattedLineTotal: '$10.05',
};

const LINE_3 = {
  ProductId: 'gid://shopify/Product/line3',
  RequiresShipping: true,
  LineDiscountedPriceCurrencyCode: 'USD',
  SellingPlanName: '1 month',
  CurrentPriceCurrencyCode: 'USD',
  VariantId: 'gid://shopify/ProductVariant/38297425182914',
  Quantity: 1,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  SellingPlanId: 'gid://shopify/SellingPlan/41615554',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  SubscriptionContractId: 'gid://shopify/SubscriptionContract/TEST',
  SubscriptionContractLineId:
    'gid://shopify/SubscriptionLine/671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  VariantImageSrc:
    'https://cdn.shopify.com/s/files/1/0507/1611/5138/products/Xnip2021-01-18_10-38-56_350x350.jpg?v=1610962790',
  CurrentPriceAmount: '15.25',
  Title: 'Test Product 3',
  VariantTitle: '',
  ItemTypeSubscriptionStatusNextBillingDate: `SCL#ACTIVE#${nextBillingDateOneMonth}`,
  SK: '#SCL#671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  PK: 'SC#TEST',
  LineDiscountedPriceAmount: '15.25',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST',
  FormattedItemPrice: '$15.25',
  FormattedLineTotal: '$15.25',
};

const LINE_4 = {
  ProductId: 'gid://shopify/Product/line4',
  RequiresShipping: true,
  LineDiscountedPriceCurrencyCode: 'USD',
  SellingPlanName: '1 month',
  CurrentPriceCurrencyCode: 'USD',
  VariantId: 'gid://shopify/ProductVariant/38297425182914',
  Quantity: 1,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  SellingPlanId: 'gid://shopify/SellingPlan/41615554',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  SubscriptionContractId: 'gid://shopify/SubscriptionContract/TEST',
  SubscriptionContractLineId:
    'gid://shopify/SubscriptionLine/671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  VariantImageSrc:
    'https://cdn.shopify.com/s/files/1/0507/1611/5138/products/photo-1590559430288-a5bc0294aac7_350x350.jpg?v=1615968594',
  CurrentPriceAmount: '15.25',
  Title: 'Test Product 4',
  VariantTitle: '',
  ItemTypeSubscriptionStatusNextBillingDate: `SCL#ACTIVE#${nextBillingDateOneMonth}`,
  SK: '#SCL#671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  PK: 'SC#TEST',
  LineDiscountedPriceAmount: '15.25',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST',
  FormattedItemPrice: '$15.25',
  FormattedLineTotal: '$15.25',
};

const LINE_5 = {
  ProductId: 'gid://shopify/Product/line5',
  RequiresShipping: true,
  LineDiscountedPriceCurrencyCode: 'USD',
  SellingPlanName: '1 month',
  CurrentPriceCurrencyCode: 'USD',
  VariantId: 'gid://shopify/ProductVariant/38297425182914',
  Quantity: 1,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  SellingPlanId: 'gid://shopify/SellingPlan/41615554',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  SubscriptionContractId: 'gid://shopify/SubscriptionContract/TEST',
  SubscriptionContractLineId:
    'gid://shopify/SubscriptionLine/671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  VariantImageSrc:
    'https://cdn.shopify.com/s/files/1/0507/1611/5138/products/Xnip2021-03-11_17-08-05_350x350.jpg?v=1615478914',
  CurrentPriceAmount: '15.25',
  Title: 'Test Product 3',
  VariantTitle: '',
  ItemTypeSubscriptionStatusNextBillingDate: `SCL#ACTIVE#${nextBillingDateOneMonth}`,
  SK: '#SCL#671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  PK: 'SC#TEST',
  LineDiscountedPriceAmount: '15.25',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST5',
  FormattedItemPrice: '$15.25',
  FormattedLineTotal: '$15.25',
};

const LINE_6 = {
  ProductId: 'gid://shopify/Product/line5',
  RequiresShipping: true,
  LineDiscountedPriceCurrencyCode: 'USD',
  SellingPlanName: '1 month',
  CurrentPriceCurrencyCode: 'USD',
  VariantId: 'gid://shopify/ProductVariant/38297425182914',
  Quantity: 1,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  SellingPlanId: 'gid://shopify/SellingPlan/41615554',
  CustomAttributes: [
    {
      value: '12 items',
      key: '_bundleLabel',
      __typename: 'Attribute',
    },
    {
      value: 'gid://shopify/Product/6867530055865',
      key: '_bundleProductId',
      __typename: 'Attribute',
    },
    {
      value: 'Build-a-box',
      key: '_bundleName',
      __typename: 'Attribute',
    },
    {
      value: '12',
      key: '_bundleBoxSize',
      __typename: 'Attribute',
    },
    {
      value: '0',
      key: '_bundleBoxPrice',
      __typename: 'Attribute',
    },
    {
      value: '1',
      key: '_pv_40603874164921',
      __typename: 'Attribute',
    },
    {
      value: '1',
      key: 'Smoothies - Train your dragon',
      __typename: 'Attribute',
    },
    {
      value: '2',
      key: '_pv_40603874230457',
      __typename: 'Attribute',
    },
    {
      value: '2',
      key: 'Smoothies - Super Monkey',
      __typename: 'Attribute',
    },
    {
      value: '1',
      key: '_pv_40603874263225',
      __typename: 'Attribute',
    },
    {
      value: '1',
      key: 'Smoothies - Lime Feeln Good',
      __typename: 'Attribute',
    },
    {
      value: '2',
      key: '_pv_40603874328761',
      __typename: 'Attribute',
    },
    {
      value: '2',
      key: 'Smoothies - Guac My World',
      __typename: 'Attribute',
    },
    {
      value: '1',
      key: '_pv_40603874361529',
      __typename: 'Attribute',
    },
    {
      value: '1',
      key: "Smoothies - Don't Kale my Vibe",
      __typename: 'Attribute',
    },
    {
      value: '1',
      key: '_pv_40603874394297',
      __typename: 'Attribute',
    },
    {
      value: '1',
      key: 'Smoothies - Cold Brewsky',
      __typename: 'Attribute',
    },
    {
      value: '3',
      key: '_pv_40603874427065',
      __typename: 'Attribute',
    },
    {
      value: '3',
      key: 'Smoothies - Coco Loco',
      __typename: 'Attribute',
    },
    {
      value: '1',
      key: '_pv_40603874459833',
      __typename: 'Attribute',
    },
    {
      value: '1',
      key: 'Smoothies - Banana Stand',
      __typename: 'Attribute',
    },
  ],
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  SubscriptionContractId: 'gid://shopify/SubscriptionContract/TEST',
  SubscriptionContractLineId:
    'gid://shopify/SubscriptionLine/671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  VariantImageSrc:
    'https://cdn.shopify.com/s/files/1/0507/1611/5138/products/Xnip2021-03-11_17-08-05_350x350.jpg?v=1615478914',
  CurrentPriceAmount: '15.25',
  Title: 'My Box',
  VariantTitle: '',
  ItemTypeSubscriptionStatusNextBillingDate: `SCL#ACTIVE#${nextBillingDateOneMonth}`,
  SK: '#SCL#671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  PK: 'SC#TEST',
  LineDiscountedPriceAmount: '15.25',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST5',
  FormattedItemPrice: '$15.25',
  FormattedLineTotal: '$15.25',
};

const LINE_7 = {
  ProductId: 'gid://shopify/Product/line5',
  RequiresShipping: true,
  LineDiscountedPriceCurrencyCode: 'USD',
  SellingPlanName: '1 month',
  CurrentPriceCurrencyCode: 'USD',
  VariantId: 'gid://shopify/ProductVariant/38297425182914',
  Quantity: 1,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  SellingPlanId: 'gid://shopify/SellingPlan/41615554',
  CustomAttributes: [
    { key: '_bundleProductId', value: '3123131312' },
    { key: '_addon', value: '1' },
  ],
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  SubscriptionContractId: 'gid://shopify/SubscriptionContract/TEST',
  SubscriptionContractLineId:
    'gid://shopify/SubscriptionLine/671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  VariantImageSrc:
    'https://cdn.shopify.com/s/files/1/0507/1611/5138/products/Xnip2021-03-11_17-08-05_350x350.jpg?v=1615478914',
  CurrentPriceAmount: '15.25',
  Title: 'Test Product 3',
  VariantTitle: 'Addon',
  ItemTypeSubscriptionStatusNextBillingDate: `SCL#ACTIVE#${nextBillingDateOneMonth}`,
  SK: '#SCL#671f3d8a-f680-49b2-b079-2f7ffa58a4cd',
  PK: 'SC#TEST',
  LineDiscountedPriceAmount: '15.25',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST5',
  FormattedItemPrice: '$15.25',
  FormattedLineTotal: '$15.25',
};

const TEST_SUBSCRIPTION_1: Subscription = {
  SubscriptionContractNextBillingDate: nextBillingDateOneMonth,
  UpdatedAt: '2021-05-18T05:43:04Z',
  DeliveryIntervalDeliveryCount: 'MONTH#1',
  DeliveryMethod: {
    shippingOptions: {
      presentmentTitle: 'Standard',
      description: '',
      code: 'Standard',
    },
    address: {
      zip: '98109',
      country: 'United States',
      province: 'Washington',
      address2: '',
      city: 'Seattle',
      address1: '123 Main Street',
      countryCode: 'US',
      provinceCode: 'WA',
      name: 'Brian Singer',
      firstName: 'Brian',
      lastName: 'Singer',
    },
  },
  DeliveryPriceAmount: 5,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  CurrencyCode: 'USD',
  SubscriptionStatus: 'ACTIVE',
  CustomerPaymentMethod: {
    revokedAt: '',
    instrument: {
      expiryMonth: '6',
      lastDigits: '4242',
      expiryYear: '2026',
      billingAddress: {
        zip: '98109',
        country: 'United States',
        province: 'Washington',
        city: 'Seattle',
        address1: '123 Main Street',
        countryCode: 'US',
        provinceCode: 'WA',
        address2: '',
        firstName: 'Brian',
        lastName: 'Singer',
      },
      brand: 'visa',
      __typename: 'CustomerCreditCard',
    },
    id: 'gid://shopify/CustomerPaymentMethod/53f5ab57773d6aba9ff55d9960bc98ea',
  },
  BillingIntervalBillingCount: 'MONTH#1',
  ItemTypeSubscriptionStatusNextBillingDate: `SC#ACTIVE#${nextBillingDateOneMonth}`,
  SK: '#SC#TEST1234',
  LineCount: 1,
  PK: 'SHOP#bundleco-store.myshopify.com',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST1',
  CreatedAt: '2021-03-24T12:26:24Z',
  Customer: {
    Email: 'test@test.com',
    productSubscriberStatus: 'ACTIVE',
    Phone: '',
    VerifiedPhone: false,
    displayName: 'Brian Singer',
    imageSrc:
      'https://cdn.shopify.com/proxy/64485ae091097e00b0cd756b9f886f1a59bb5ce16774a834f1aba70d533302b5/www.gravatar.com/avatar/146ef7f5bda081f46178e87c010194b6.jpg?s=5760&d=https%3A%2F%2Fcdn.shopify.com%2Fshopifycloud%2Fshopify%2Fassets%2Fadmin%2Fcustomers%2Fpolaris%2Favatar-2-18c76b52ae7cb4c280a365d862903882a33d839a410c8e034799935ebf47503c.png',
    validEmailAddress: true,
    id: 'gid://shopify/Customer/5063555547330',
    locale: 'en',
    acceptsMarketing: false,
    email: 'brian.c.singer+demo@gmail.com',
    verifiedEmail: true,
  },
  DeliveryPriceCurrencyCode: 'USD',
  FormattedSubscriptionTotal: '$20.17',
  FormattedDeliveryPrice: '$5.00',
  FormattedFrequency: 'Once a month',
  Lines: [LINE_1],
  FormattedSubscriptionSubtotal: '$15.17',
  SubscriptionTotal: '20.17',
};

const TEST_SUBSCRIPTION_2: Subscription = {
  SubscriptionContractNextBillingDate: nextBillingDateTwoWeeks,
  UpdatedAt: '2021-05-18T05:43:04Z',
  DeliveryIntervalDeliveryCount: 'WEEK#2',
  DeliveryMethod: {
    shippingOptions: {
      presentmentTitle: 'Standard',
      description: '',
      code: 'Standard',
    },
    address: {
      zip: '98109',
      country: 'United States',
      province: 'Washington',
      address2: '',
      city: 'Seattle',
      address1: '123 Main Street',
      countryCode: 'US',
      provinceCode: 'WA',
      name: 'Brian Singer',
      firstName: 'Brian',
      lastName: 'Singer',
    },
  },
  DeliveryPriceAmount: 5,
  NextBillingDate: nextBillingDateTwoWeeks,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  CurrencyCode: 'USD',
  SubscriptionStatus: 'ACTIVE',
  CustomerPaymentMethod: {
    revokedAt: '',
    instrument: {
      expiryMonth: '6',
      lastDigits: '4242',
      expiryYear: '2026',
      billingAddress: {
        zip: '98109',
        country: 'United States',
        province: 'Washington',
        city: 'Seattle',
        address1: '123 Main Street',
        countryCode: 'US',
        provinceCode: 'WA',
        address2: '',
        firstName: 'Brian',
        lastName: 'Singer',
      },
      brand: 'visa',
      __typename: 'CustomerCreditCard',
    },
    id: 'gid://shopify/CustomerPaymentMethod/53f5ab57773d6aba9ff55d9960bc98ea',
  },
  BillingIntervalBillingCount: 'WEEK#2',
  ItemTypeSubscriptionStatusNextBillingDate: `SC#ACTIVE#${nextBillingDateTwoWeeks}`,
  SK: '#SC#TEST',
  LineCount: 1,
  PK: 'SHOP#bundleco-store.myshopify.com',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST2',
  CreatedAt: '2021-03-24T12:26:24Z',
  Customer: {
    productSubscriberStatus: 'ACTIVE',
    Phone: '',
    VerifiedPhone: false,
    displayName: 'Brian Singer',
    imageSrc:
      'https://cdn.shopify.com/proxy/64485ae091097e00b0cd756b9f886f1a59bb5ce16774a834f1aba70d533302b5/www.gravatar.com/avatar/146ef7f5bda081f46178e87c010194b6.jpg?s=5760&d=https%3A%2F%2Fcdn.shopify.com%2Fshopifycloud%2Fshopify%2Fassets%2Fadmin%2Fcustomers%2Fpolaris%2Favatar-2-18c76b52ae7cb4c280a365d862903882a33d839a410c8e034799935ebf47503c.png',
    validEmailAddress: true,
    id: 'gid://shopify/Customer/5063555547330',
    locale: 'en',
    acceptsMarketing: false,
    email: 'brian.c.singer+demo@gmail.com',
    verifiedEmail: true,
  },
  DeliveryPriceCurrencyCode: 'USD',
  FormattedSubscriptionTotal: '$50.32',
  FormattedDeliveryPrice: '$5.00',
  FormattedFrequency: 'Once every two weeks',
  Lines: [LINE_1, LINE_2],
  FormattedSubscriptionSubtotal: '$45.32',
  SubscriptionTotal: '50.32',
};

const TEST_SUBSCRIPTION_3: Subscription = {
  SubscriptionContractNextBillingDate: nextBillingDateOneMonth,
  UpdatedAt: '2021-05-18T05:43:04Z',
  DeliveryIntervalDeliveryCount: 'MONTH#1',
  DeliveryMethod: {
    shippingOptions: {
      presentmentTitle: 'Standard',
      description: '',
      code: 'Standard',
    },
    address: {
      zip: '98109',
      country: 'United States',
      province: 'Washington',
      address2: '',
      city: 'Seattle',
      address1: '123 Main Street',
      countryCode: 'US',
      provinceCode: 'WA',
      name: 'Brian Singer',
      firstName: 'Brian',
      lastName: 'Singer',
    },
  },
  DeliveryPriceAmount: 5,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  CurrencyCode: 'USD',
  SubscriptionStatus: 'CANCELLED',
  CustomerPaymentMethod: {
    revokedAt: '',
    instrument: {
      expiryMonth: '6',
      lastDigits: '4242',
      expiryYear: '2026',
      billingAddress: {
        zip: '98109',
        country: 'United States',
        province: 'Washington',
        city: 'Seattle',
        address1: '123 Main Street',
        countryCode: 'US',
        provinceCode: 'WA',
        address2: '',
        firstName: 'Brian',
        lastName: 'Singer',
      },
      brand: 'visa',
      __typename: 'CustomerCreditCard',
    },
    id: 'gid://shopify/CustomerPaymentMethod/53f5ab57773d6aba9ff55d9960bc98ea',
  },
  BillingIntervalBillingCount: 'MONTH#1',
  ItemTypeSubscriptionStatusNextBillingDate: `SC#CANCELLED#${nextBillingDateOneMonth}`,
  SK: '#SC#TEST',
  LineCount: 1,
  PK: 'SHOP#bundleco-store.myshopify.com',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST3',
  CreatedAt: '2021-03-24T12:26:24Z',
  Customer: {
    productSubscriberStatus: 'CANCELLED',
    Phone: '',
    VerifiedPhone: false,
    displayName: 'Brian Singer',
    imageSrc:
      'https://cdn.shopify.com/proxy/64485ae091097e00b0cd756b9f886f1a59bb5ce16774a834f1aba70d533302b5/www.gravatar.com/avatar/146ef7f5bda081f46178e87c010194b6.jpg?s=5760&d=https%3A%2F%2Fcdn.shopify.com%2Fshopifycloud%2Fshopify%2Fassets%2Fadmin%2Fcustomers%2Fpolaris%2Favatar-2-18c76b52ae7cb4c280a365d862903882a33d839a410c8e034799935ebf47503c.png',
    validEmailAddress: true,
    id: 'gid://shopify/Customer/5063555547330',
    locale: 'en',
    acceptsMarketing: false,
    email: 'brian.c.singer+demo@gmail.com',
    verifiedEmail: true,
  },
  DeliveryPriceCurrencyCode: 'USD',
  FormattedSubscriptionTotal: '$20.25',
  FormattedDeliveryPrice: '$5.00',
  FormattedFrequency: 'Once a month',
  Lines: [LINE_3],
  FormattedSubscriptionSubtotal: '$15.25',
  SubscriptionTotal: '20.25',
};

const TEST_SUBSCRIPTION_4: Subscription = {
  SubscriptionContractNextBillingDate: nextBillingDateOneMonth,
  UpdatedAt: '2021-05-18T05:43:04Z',
  DeliveryIntervalDeliveryCount: 'MONTH#1',
  DeliveryMethod: {
    shippingOptions: {
      presentmentTitle: 'Standard',
      description: '',
      code: 'Standard',
    },
    address: {
      zip: '98109',
      country: 'United States',
      province: 'Washington',
      address2: '',
      city: 'Seattle',
      address1: '123 Main Street',
      countryCode: 'US',
      provinceCode: 'WA',
      name: 'Brian Singer',
      firstName: 'Brian',
      lastName: 'Singer',
    },
  },
  DeliveryPriceAmount: 5,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  CurrencyCode: 'USD',
  SubscriptionStatus: 'PAUSED',
  CustomerPaymentMethod: {
    revokedAt: '',
    instrument: {
      expiryMonth: '6',
      lastDigits: '4242',
      expiryYear: '2026',
      billingAddress: {
        zip: '98109',
        country: 'United States',
        province: 'Washington',
        city: 'Seattle',
        address1: '123 Main Street',
        countryCode: 'US',
        provinceCode: 'WA',
        address2: '',
        firstName: 'Brian',
        lastName: 'Singer',
      },
      brand: 'visa',
      __typename: 'CustomerCreditCard',
    },
    id: 'gid://shopify/CustomerPaymentMethod/53f5ab57773d6aba9ff55d9960bc98ea',
  },
  BillingIntervalBillingCount: 'MONTH#1',
  ItemTypeSubscriptionStatusNextBillingDate: `SC#PAUSED#${nextBillingDateOneMonth}`,
  SK: '#SC#TEST',
  LineCount: 1,
  PK: 'SHOP#bundleco-store.myshopify.com',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST4',
  CreatedAt: '2021-03-24T12:26:24Z',
  Customer: {
    productSubscriberStatus: 'PAUSED',
    Phone: '',
    VerifiedPhone: false,
    displayName: 'Brian Singer',
    imageSrc:
      'https://cdn.shopify.com/proxy/64485ae091097e00b0cd756b9f886f1a59bb5ce16774a834f1aba70d533302b5/www.gravatar.com/avatar/146ef7f5bda081f46178e87c010194b6.jpg?s=5760&d=https%3A%2F%2Fcdn.shopify.com%2Fshopifycloud%2Fshopify%2Fassets%2Fadmin%2Fcustomers%2Fpolaris%2Favatar-2-18c76b52ae7cb4c280a365d862903882a33d839a410c8e034799935ebf47503c.png',
    validEmailAddress: true,
    id: 'gid://shopify/Customer/5063555547330',
    locale: 'en',
    acceptsMarketing: false,
    email: 'brian.c.singer+demo@gmail.com',
    verifiedEmail: true,
  },
  DeliveryPriceCurrencyCode: 'USD',
  FormattedSubscriptionTotal: '$20.25',
  FormattedDeliveryPrice: '$5.00',
  FormattedFrequency: 'Once a month',
  Lines: [LINE_4],
  FormattedSubscriptionSubtotal: '$15.25',
  SubscriptionTotal: '20.25',
};

const TEST_SUBSCRIPTION_5: Subscription = {
  SubscriptionContractNextBillingDate: nextBillingDateOneMonth,
  UpdatedAt: '2021-05-18T05:43:04Z',
  DeliveryIntervalDeliveryCount: 'MONTH#1',
  DeliveryMethod: {
    shippingOptions: {
      presentmentTitle: 'Standard',
      description: '',
      code: 'Standard',
    },
    address: {
      zip: '98109',
      country: 'United States',
      province: 'Washington',
      address2: '',
      city: 'Seattle',
      address1: '123 Main Street',
      countryCode: 'US',
      provinceCode: 'WA',
      name: 'Brian Singer',
      firstName: 'Brian',
      lastName: 'Singer',
    },
  },
  DeliveryPriceAmount: 5,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  CurrencyCode: 'USD',
  SubscriptionStatus: 'PAUSED',
  CustomerPaymentMethod: {
    revokedAt: '',
    instrument: {
      expiryMonth: '6',
      lastDigits: '4242',
      expiryYear: '2026',
      billingAddress: {
        zip: '98109',
        country: 'United States',
        province: 'Washington',
        city: 'Seattle',
        address1: '123 Main Street',
        countryCode: 'US',
        provinceCode: 'WA',
        address2: '',
        firstName: 'Brian',
        lastName: 'Singer',
      },
      brand: 'visa',
      __typename: 'CustomerCreditCard',
    },
    id: 'gid://shopify/CustomerPaymentMethod/53f5ab57773d6aba9ff55d9960bc98ea',
  },
  BillingIntervalBillingCount: 'MONTH#1',
  ItemTypeSubscriptionStatusNextBillingDate: `SC#PAUSED#${nextBillingDateOneMonth}`,
  SK: '#SC#TEST',
  LineCount: 1,
  PK: 'SHOP#bundleco-store.myshopify.com',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST5',
  CreatedAt: '2021-03-24T12:26:24Z',
  Customer: {
    productSubscriberStatus: 'PAUSED',
    Phone: '',
    VerifiedPhone: false,
    displayName: 'Brian Singer',
    imageSrc:
      'https://cdn.shopify.com/proxy/64485ae091097e00b0cd756b9f886f1a59bb5ce16774a834f1aba70d533302b5/www.gravatar.com/avatar/146ef7f5bda081f46178e87c010194b6.jpg?s=5760&d=https%3A%2F%2Fcdn.shopify.com%2Fshopifycloud%2Fshopify%2Fassets%2Fadmin%2Fcustomers%2Fpolaris%2Favatar-2-18c76b52ae7cb4c280a365d862903882a33d839a410c8e034799935ebf47503c.png',
    validEmailAddress: true,
    id: 'gid://shopify/Customer/5063555547330',
    locale: 'en',
    acceptsMarketing: false,
    email: 'brian.c.singer+demo@gmail.com',
    verifiedEmail: true,
  },
  DeliveryPriceCurrencyCode: 'USD',
  FormattedSubscriptionTotal: '$20.25',
  FormattedDeliveryPrice: '$5.00',
  FormattedFrequency: 'Once a month',
  Lines: [LINE_5],
  FormattedSubscriptionSubtotal: '$15.25',
  SubscriptionTotal: '20.25',
};

const TEST_SUBSCRIPTION_6: Subscription = {
  SubscriptionContractNextBillingDate: nextBillingDateOneMonth,
  UpdatedAt: '2021-05-18T05:43:04Z',
  DeliveryIntervalDeliveryCount: 'MONTH#1',
  DeliveryMethod: {
    shippingOptions: {
      presentmentTitle: 'Standard',
      description: '',
      code: 'Standard',
    },
    address: {
      zip: '98109',
      country: 'United States',
      province: 'Washington',
      address2: '',
      city: 'Seattle',
      address1: '123 Main Street',
      countryCode: 'US',
      provinceCode: 'WA',
      name: 'Brian Singer',
      firstName: 'Brian',
      lastName: 'Singer',
    },
  },
  DeliveryPriceAmount: 5,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  CurrencyCode: 'USD',
  SubscriptionStatus: 'CANCELLED',
  CustomerPaymentMethod: {
    revokedAt: '',
    instrument: {
      expiryMonth: '6',
      lastDigits: '4242',
      expiryYear: '2026',
      billingAddress: {
        zip: '98109',
        country: 'United States',
        province: 'Washington',
        city: 'Seattle',
        address1: '123 Main Street',
        countryCode: 'US',
        provinceCode: 'WA',
        address2: '',
        firstName: 'Brian',
        lastName: 'Singer',
      },
      brand: 'visa',
      __typename: 'CustomerCreditCard',
    },
    id: 'gid://shopify/CustomerPaymentMethod/53f5ab57773d6aba9ff55d9960bc98ea',
  },
  BillingIntervalBillingCount: 'MONTH#1',
  ItemTypeSubscriptionStatusNextBillingDate: `SC#CANCELLED#${nextBillingDateOneMonth}`,
  SK: '#SC#TEST',
  LineCount: 1,
  PK: 'SHOP#bundleco-store.myshopify.com',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST5',
  CreatedAt: '2021-03-24T12:26:24Z',
  Customer: {
    productSubscriberStatus: 'PAUSED',
    Phone: '',
    VerifiedPhone: false,
    displayName: 'Brian Singer',
    imageSrc:
      'https://cdn.shopify.com/proxy/64485ae091097e00b0cd756b9f886f1a59bb5ce16774a834f1aba70d533302b5/www.gravatar.com/avatar/146ef7f5bda081f46178e87c010194b6.jpg?s=5760&d=https%3A%2F%2Fcdn.shopify.com%2Fshopifycloud%2Fshopify%2Fassets%2Fadmin%2Fcustomers%2Fpolaris%2Favatar-2-18c76b52ae7cb4c280a365d862903882a33d839a410c8e034799935ebf47503c.png',
    validEmailAddress: true,
    id: 'gid://shopify/Customer/5063555547330',
    locale: 'en',
    acceptsMarketing: false,
    email: 'brian.c.singer+demo@gmail.com',
    verifiedEmail: true,
  },
  DeliveryPriceCurrencyCode: 'USD',
  FormattedSubscriptionTotal: '$20.25',
  FormattedDeliveryPrice: '$5.00',
  FormattedFrequency: 'Once a month',
  Lines: [LINE_5],
  FormattedSubscriptionSubtotal: '$15.25',
  SubscriptionTotal: '20.25',
};

const TEST_SUBSCRIPTION_7: Subscription = {
  SubscriptionContractNextBillingDate: nextBillingDateOneMonth,
  UpdatedAt: '2021-05-18T05:43:04Z',
  DeliveryIntervalDeliveryCount: 'MONTH#1',
  DeliveryMethod: {
    shippingOptions: {
      presentmentTitle: 'Standard',
      description: '',
      code: 'Standard',
    },
    address: {
      zip: '98109',
      country: 'United States',
      province: 'Washington',
      address2: '',
      city: 'Seattle',
      address1: '123 Main Street',
      countryCode: 'US',
      provinceCode: 'WA',
      name: 'Brian Singer',
      firstName: 'Brian',
      lastName: 'Singer',
    },
  },
  DeliveryPriceAmount: 5,
  NextBillingDate: nextBillingDateOneMonth,
  CustomerId: 'gid://shopify/Customer/5063555547330',
  ShopDomain: 'bundleco-store.myshopify.com',
  NextBillingYearMonth: nextBillingYearMonth,
  CurrencyCode: 'USD',
  SubscriptionStatus: 'ACTIVE',
  CustomerPaymentMethod: {
    revokedAt: '',
    instrument: {
      expiryMonth: '6',
      lastDigits: '4242',
      expiryYear: '2026',
      billingAddress: {
        zip: '98109',
        country: 'United States',
        province: 'Washington',
        city: 'Seattle',
        address1: '123 Main Street',
        countryCode: 'US',
        provinceCode: 'WA',
        address2: '',
        firstName: 'Brian',
        lastName: 'Singer',
      },
      brand: 'visa',
      __typename: 'CustomerCreditCard',
    },
    id: 'gid://shopify/CustomerPaymentMethod/53f5ab57773d6aba9ff55d9960bc98ea',
  },
  BillingIntervalBillingCount: 'MONTH#1',
  ItemTypeSubscriptionStatusNextBillingDate: `SC#CANCELLED#${nextBillingDateOneMonth}`,
  SK: '#SC#TEST',
  LineCount: 1,
  PK: 'SHOP#bundleco-store.myshopify.com',
  SubscriptionId: 'gid://shopify/SubscriptionContract/TEST5',
  CreatedAt: '2021-03-24T12:26:24Z',
  Customer: {
    productSubscriberStatus: 'PAUSED',
    Phone: '',
    VerifiedPhone: false,
    displayName: 'Brian Singer',
    imageSrc:
      'https://cdn.shopify.com/proxy/64485ae091097e00b0cd756b9f886f1a59bb5ce16774a834f1aba70d533302b5/www.gravatar.com/avatar/146ef7f5bda081f46178e87c010194b6.jpg?s=5760&d=https%3A%2F%2Fcdn.shopify.com%2Fshopifycloud%2Fshopify%2Fassets%2Fadmin%2Fcustomers%2Fpolaris%2Favatar-2-18c76b52ae7cb4c280a365d862903882a33d839a410c8e034799935ebf47503c.png',
    validEmailAddress: true,
    id: 'gid://shopify/Customer/5063555547330',
    locale: 'en',
    acceptsMarketing: false,
    email: 'brian.c.singer+demo@gmail.com',
    verifiedEmail: true,
  },
  DeliveryPriceCurrencyCode: 'USD',
  FormattedSubscriptionTotal: '$20.25',
  FormattedDeliveryPrice: '$5.00',
  FormattedFrequency: 'Once a month',
  Lines: [LINE_6, LINE_7],
  FormattedSubscriptionSubtotal: '$15.25',
  SubscriptionTotal: '20.25',
};

const BILLING_ATTEMPT_1: BillingAttempt = {
  IdempotencyKey: '1097072834_2021-04-22T00:17',
  Ready: true,
  ErrorMessage: '',
  CompletedAt: '2021-05-02T00:17:31Z',
  ErrorCode: '',
  CustomerId: 'gid://shopify/Customer/5063555547330',
  ShopDomain: 'bundleco-store.myshopify.com',
  BillingAttemptStatus: 'SUCCESS',
  OrderId: 'gid://shopify/Order/TEST1230',
  Retry: false,
  SK: '#BA#615809218',
  NextActionUrl: '',
  PK: 'SC#1097072834',
  BillingAttemptId: 'gid://shopify/SubscriptionBillingAttempt/615809218',
  CreatedAt: '2021-05-02T00:17:28Z',
  SubscriptionId: 'gid://shopify/SubscriptionContract/1097072834',
};

const BILLING_ATTEMPT_2: BillingAttempt = {
  IdempotencyKey: '1097072834_2021-04-22T00:17',
  Ready: true,
  ErrorMessage: '',
  CompletedAt: '2021-04-02T00:17:31Z',
  ErrorCode: '',
  CustomerId: 'gid://shopify/Customer/5063555547330',
  ShopDomain: 'bundleco-store.myshopify.com',
  BillingAttemptStatus: 'FAILED',
  OrderId: 'gid://shopify/Order/TEST1220',
  Retry: false,
  SK: '#BA#615809219',
  NextActionUrl: '',
  PK: 'SC#1097072834',
  BillingAttemptId: 'gid://shopify/SubscriptionBillingAttempt/615809218',
  CreatedAt: '2021-04-02T00:17:31Z',
  SubscriptionId: 'gid://shopify/SubscriptionContract/1097072834',
};

const LIQUID_ORDER_TEST1230: LiquidOrder = {
  url: '#',
  id: 'TEST1230',
  number: '1230',
};

const LIQUID_ORDER_TEST1220: LiquidOrder = {
  url: '#',
  id: 'TEST1220',
  number: '1220',
};

const billingAttemptsMap = {
  TEST1: [BILLING_ATTEMPT_1, BILLING_ATTEMPT_2],
  TEST2: [BILLING_ATTEMPT_1],
  TEST3: [BILLING_ATTEMPT_1],
  TEST4: [BILLING_ATTEMPT_1],
  TEST5: [BILLING_ATTEMPT_1],
};

const subscriptionMap = {
  TEST1: TEST_SUBSCRIPTION_1,
  TEST2: TEST_SUBSCRIPTION_2,
  TEST3: TEST_SUBSCRIPTION_3,
  TEST4: TEST_SUBSCRIPTION_4,
  TEST5: TEST_SUBSCRIPTION_5,
  TEST7: TEST_SUBSCRIPTION_7,
};
